import {reader} from "messaging/reader.js";
import {publish} from "messaging/queue.js";
import {lazy} from './lazy.js';
import {doc} from './documentation.js';

doc(
    "send",
    {
        "type": "",
        "value": "",
    },
    "Publishes a message of a given type with a value");

export const send = (type, value) => {
    return (...args) => {
        let _type = lazy(type, ...args);
        let _value = lazy(value, ...args);
        publish(_type, _value);
        return args[0];
    };
};
doc(
    "receive",
    {
        "type": "",
        "function": "",
        "skipEmpty=true":""
    },
    "Receives a message and calls a function when it does");
export const receive = (type, fn, skipEmpty=true) => {
    let _reader = reader(type);
    return (... args) => {
        let msgs = _reader();
        if (fn) {
            let r = msgs.map((value) => {
                if (typeof fn === "function") {
                    let y = lazy(fn, ...args);
                    return y;
                } else {
                    return fn;
                }
            });
            let x = r[0] || args[0];
            return x;
        }
        return args[0];
    };
};
